export default __webpack_public_path__ + "static/mg-0aa76ab4e8913a1e74f2ed216c30823a.jpg";